// ─── 심각도 매핑 상수 ────────────────────────────────────────────
// scss $status-colors 맵 키와 동일 (danger/warning/caution/minor/neutral)
const SEVERITY_VARIANT_MAP = {
    CRITICAL: "danger",
    HIGH: "warning",
    MEDIUM: "caution",
    LOW: "minor",
    NONE: "neutral",
};

const SEVERITY_LABEL_MAP = {
    CRITICAL: "Critical",
    HIGH: "High",
    MEDIUM: "Medium",
    LOW: "Low",
    NONE: "None",
};

// ─── Composable ──────────────────────────────────────────────────
export const useCveFormat = () => {
    /**
     * CVSS 심각도 → level-badge BEM modifier 반환
     * @param {string} val  CRITICAL | HIGH | MEDIUM | LOW | NONE
     * @returns {string}    danger | warning | caution | minor | neutral | unknown
     */
    const severityVariant = (val) =>
        SEVERITY_VARIANT_MAP[String(val || "").toUpperCase()] ?? "unknown";

    /**
     * CVSS 심각도 → 영문 레이블 반환
     */
    const severityName = (val) => SEVERITY_LABEL_MAP[String(val || "").toUpperCase()] ?? "Unknown";

    /**
     * CVSS 점수 포맷
     * - null / undefined / '' → null (배지에서 "평가 전" 처리)
     * - 정수 → "10"
     * - 소수 → "7.2" (1자리)
     */
    const formatScore = (score) => {
        if (score == null || score === "") return null;
        const n = Number(score);
        return Number.isNaN(n) ? String(score) : Number.isInteger(n) ? String(n) : n.toFixed(1);
    };

    /**
     * ISO 날짜 문자열 → YYYY-MM-DD
     */
    const formatDate = (val) => {
        if (!val) return "-";
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? String(val).slice(0, 10) : d.toISOString().slice(0, 10);
    };

    return { severityVariant, severityName, formatScore, formatDate };
};
